import React, { Component } from 'react';
import firebase from '../store/firebase';

class ExecutiveMembersTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      execMembers: [],
      filteredMembers: [],
      companyOptions: [],
      selectedCompany: '',           // empty → no selection yet
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    this.fetchExecutiveMembers();
  }

  fetchExecutiveMembers = async () => {
    try {
      const db = firebase.database;
      const usersRef = db.ref('user');
      const usersSnapshot = await usersRef.once('value');

      const execMembers = [];

      usersSnapshot.forEach((childSnapshot) => {
        const user = childSnapshot.val();
        if (user?.execmember === true) {
          const points = Number(user.points) || 0;
          execMembers.push({
            email:       user.email       || '—',
            companyName: user.companyName || '—',
            points:      points / 100
          });
        }
      });

      execMembers.sort((a, b) => b.points - a.points);

      // Unique companies + "All Companies" at the beginning
      const uniqueCompanies = [...new Set(
        execMembers
          .map(m => m.companyName)
          .filter(name => name !== '—' && name.trim() !== '')
      )];

      this.setState({
        execMembers,
        filteredMembers: [],                    // start empty
        companyOptions: ['All Companies', ...uniqueCompanies],
        selectedCompany: '',                    // no selection yet
        loading: false
      });
    } catch (err) {
      console.error("Failed to load executive members:", err);
      this.setState({
        error: "Could not load data. Please try again later.",
        loading: false
      });
    }
  };

  handleCompanyChange = (e) => {
    const selected = e.target.value;
    const { execMembers } = this.state;

    let filtered = [];
    if (selected) {
      if (selected === 'All Companies') {
        filtered = [...execMembers];
      } else {
        filtered = execMembers.filter(member => member.companyName === selected);
      }
    }

    this.setState({
      selectedCompany: selected,
      filteredMembers: filtered
    });
  };

  render() {
    const { filteredMembers, companyOptions, selectedCompany, loading, error } = this.state;

    if (loading) {
      return (
        <div style={{ padding: '40px', textAlign: 'center', color: '#555' }}>
          Loading executive members...
        </div>
      );
    }

    if (error) {
      return (
        <div style={{ padding: '40px', color: '#c62828', textAlign: 'center' }}>
          {error}
        </div>
      );
    }

    return (
      <div style={{ padding: '20px', maxWidth: '960px', margin: '0 auto' }}>
        <h2 style={{ marginBottom: '20px', color: '#333' }}>
          Executive Committee Members
        </h2>

        {/* Dropdown */}
        <div style={{ marginBottom: '24px' }}>
          <label 
            htmlFor="company-filter" 
            style={{ marginRight: '12px', fontWeight: 'bold', color: '#444' }}
          >
            Select Company:
          </label>
          <select
            id="company-filter"
            value={selectedCompany}
            onChange={this.handleCompanyChange}
            style={{
              padding: '8px 12px',
              fontSize: '15px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              minWidth: '280px',
              backgroundColor: '#fff'
            }}
          >
            <option value="" disabled>
              — Select a company —
            </option>
            {companyOptions.map((company, idx) => (
              <option key={idx} value={company}>
                {company}
              </option>
            ))}
          </select>
        </div>

        {/* Content area */}
        {selectedCompany === '' ? (
          <div style={{ 
            padding: '40px 20px', 
            backgroundColor: '#f9f9f9', 
            borderRadius: '8px', 
            textAlign: 'center', 
            color: '#666' 
          }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '8px' }}>
              Please select a company from the dropdown above
            </p>
            <p style={{ fontSize: '0.95rem' }}>
              to view its executive members and points (or choose "All Companies").
            </p>
          </div>
        ) : filteredMembers.length === 0 ? (
          <p style={{ color: '#666', fontStyle: 'italic', padding: '20px 0' }}>
            No executive members found for <strong>{selectedCompany}</strong>.
          </p>
        ) : (
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '15px',
              backgroundColor: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}
          >
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 'bold', color: '#444' }}>
                  Email
                </th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 'bold', color: '#444' }}>
                  Company Name
                </th>
                <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 'bold', color: '#444' }}>
                  Points
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredMembers.map((member, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fafafa' : '#ffffff',
                    borderBottom: '1px solid #eee'
                  }}
                >
                  <td style={{ padding: '11px 16px' }}>{member.email}</td>
                  <td style={{ padding: '11px 16px' }}>{member.companyName}</td>
                  <td style={{ padding: '11px 16px', textAlign: 'right', fontWeight: member.points > 0 ? '500' : 'normal' }}>
                    {member.points.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default ExecutiveMembersTable;